import React, { useState, useEffect, FC } from "react";
import { Table, Button, Input, Select, Checkbox, Tooltip } from "antd";
import { YHModal } from "@/components/YHModal";
import { useStockCheckDetailModel, IMaterialDetailModel } from "./stockCheckDetailsModel";
import { ColumnsType } from "antd/lib/table";
import { YhBox } from "@/components/YhBox";
import useNavModel, { RouterParamType } from "@/model/navModel";
import { YhBut } from "@/components/YhButton";
import { formatInt, formatIntPoint } from "@/utils/utils";
import { IStockStatisticDetail } from "@/views/stock/statistic/stockStatisticService";
import { EditableRow, EditableCell } from "@/components/YHEditTable/editTable";
import { useDictModel } from "../../../../base/dict/dictModel";
import { DictCodeEnmu } from "@/types/VrmSaDictEnums";
import useGlobalModel, { transOptions } from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";
enum OPT_TYPE {
    ADD = 1,
    REMOVE = 2
}
export const AddMaterialModal: FC<RouterParamType> = ({ id, mode }) => {
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { setLocale,warehouseList } = useGlobalModel()
    const Locale = setLocale(LanguageArr)

    const { addModalVisible: visible, workDataSource, searchWorkData, workPgCfg, addDataSource, transformsToRoDetailList, resetWorkloadData, workloadData, setAddDataSource, setWorkPgCfg, setSearchWorkData, setWorkDataSource, setAddModalVisible } = useStockCheckDetailModel();
    const { getSelectedDictOne } = useDictModel();

    useEffect(() => {
        workloadData()
    }, [])

    const column = (optype: number) => [
        {
            // title: '序号',
            title: Locale['SN'],
            width: 40,
            fixed: "left",
            render: (t: any, r: any, i: number) => <>{i + 1}</>
        }, {
            // title: '商品编号',
            title: Locale['Material Code'],
            width: 100,
            dataIndex: 'materialCode',
            render: (text: any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,
        }, {
            // title: '商品名称',
            title: Locale['Material Name'],
            width: 140,
            dataIndex: 'materialName',
            render: (text: any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,
        }, {
            // title: '商品名称-英文',
            title: Locale['Material Name En'],
            width: 140,
            dataIndex: 'nameEn',
            render: (text: any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,
        }, {
            // title: '库存',
            title: Locale['Inventory'],
            width: 80,
            dataIndex: 'inventoryNum',
        },{
            // title: '数量',
            title: Locale['Qty'],
            width: 80,
            dataIndex: 'num',
            editable: true,
        }, {
            // title: '平均进货价 ',
            title: Locale['Latest Purchase Price'],
            width: 130,
            dataIndex: 'latestPurPrice',
            // editable: true,            
        }, 
        // {
        //     // title: '最近销售价',
        //     title: Locale['SN'],
        //     width: 120,
        //     dataIndex: 'lateSalePrice',
        //     // editable: true,
        // }, 
         {
            // title: '原厂编号',
            title: Locale['Manufacturer Codes'],
            width: 160,
            dataIndex: 'replaceCode',
            render: (text: any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,

        }, {
            // title: '产地',
            title: Locale['Production Place'],
            width: 160,
            dataIndex: 'madeFrom',
        }, {
            // title: '规格',
            title: Locale['Spec'],
            width: 160,
            dataIndex: 'model',
        }, {
            // title: '单位',
            title: Locale['Unit'],
            width: 120,
            dataIndex: 'unitName',
        },
        {
            // title: '金额',
            title: Locale['Amount'],
            width: 120,
            dataIndex: 'amount',
        }, {
            // title: '仓库',
            title: Locale['Warehouse'],
            width: 120,
            dataIndex: 'warehouseName',
        }, {
            // title: '货位',
            title: Locale['Shelf'],
            width: 120,
            dataIndex: 'shelfCode',
        }, {
            // title: '操作',
            title: Locale['Operation'],
            width: 60,
            fixed: "right",
            render: (text: any, record: any) => optype == OPT_TYPE.ADD ? (
                <YhBut
                    type="add"
                    // txt="添加"
                    txt={Locale['Add']}
                    click={() => add(record)}
                    disabled={
                        !!addDataSource.find(item => item.id === record.id)
                        // || record.inventoryNum == 0
                    }
                />
            ) : (
                    <YhBut
                        type="delete"
                        // txt="删除"
                        txt={Locale['Delete']}
                        click={() => remove(record)}
                    />
                )
        }
    ];
    const newSelectColumns = (optType: number) =>
        column(optType).map((col: any, index) => {
            return {
                ...col,
                onCell: (record: IMaterialDetailModel, rowIndex: number) => ({
                    colIndex: index,
                    rowIndex,
                    record,
                    rules: col.rules,
                    options: col.options,
                    editType: col.editType,
                    editable: col?.editable,
                    dataIndex: col.dataIndex,
                    title: col.title,
                    handleSave: optType == OPT_TYPE.ADD ? notHandleSave : handleSave,
                }),
            }
        })
    const notHandleSave = (row: IMaterialDetailModel) => {
        let { num, lateSalePrice, inventoryNum, latestPurPrice, averagePurchasePrice } = row
        num = +formatIntPoint(num);
        averagePurchasePrice = +formatIntPoint(averagePurchasePrice);
        inventoryNum = +formatIntPoint(inventoryNum);
        let newRow = {
            ...row,
            // num: +formatIntPoint(num, inventoryNum, "选择数量≥库存数量"),
            amount: (num * averagePurchasePrice).toFixed(2)
        }
        const index = workDataSource.findIndex((item) => row.id === item.id);
        const item = workDataSource[index];
        workDataSource.splice(index, 1, { ...item, ...newRow });
        setWorkDataSource([...workDataSource])
    }
    const handleSave = (row: IMaterialDetailModel) => {
        let { num, lateSalePrice, inventoryNum, latestPurPrice, averagePurchasePrice } = row
        num = +formatIntPoint(num);
        averagePurchasePrice = +formatIntPoint(averagePurchasePrice);
        inventoryNum = +formatIntPoint(inventoryNum);
        let newRow = {
            ...row,
            // num: +formatIntPoint(num, inventoryNum, "选择数量≥库存数量"),
            amount: (num * averagePurchasePrice).toFixed(2)
        }
        const index = addDataSource.findIndex((item) => row.id === item.id);
        const item = addDataSource[index];
        addDataSource.splice(index, 1, { ...item, ...newRow });
        setAddDataSource([...addDataSource])
    }
    const add = async (record: IMaterialDetailModel) => {
        record.averagePurchasePrice=record.latestPurPrice
        setAddDataSource(origin => [...origin, record])
    }
    const remove = async (record: IMaterialDetailModel) => {
        const filterAddDataSource = addDataSource.filter(item => item.id != record.id)
        setAddDataSource(filterAddDataSource)
    }
    const rightChildren = <div className="flex">
        <Input
            allowClear
            datatype="round"
            className="border-r-16 mr-10"
            value={searchWorkData.materialCode}
            style={{ width: "150px" }}
            onChange={(e) => { setSearchWorkData({ ...searchWorkData, materialCode: e.target.value }) }}
            // placeholder="商品编码"
            placeholder={Locale['Material Code']}
        />
        <Input
            allowClear
            datatype="round"
            className="border-r-16 mr-10"
            value={searchWorkData.materialName}
            style={{ width: "150px" }}
            onChange={(e) => { setSearchWorkData({ ...searchWorkData, materialName: e.target.value }) }}
            // placeholder="商品名称"
            placeholder={Locale['Material Name']}
        />
        <Select
            allowClear
            className="border-r-16 mr-10 ant-select-round"
            value={searchWorkData.warehouseCode}
            options={transOptions(warehouseList)}
            onChange={(e) => { setSearchWorkData({ ...searchWorkData, warehouseCode: e }) }}
            style={{ width: "150px" }}
            // placeholder="仓库名称"
            placeholder={Locale['Warehouse Name']}
        />
        <Select
            allowClear
            className="border-r-16 mr-10 ant-select-round"
            value={searchWorkData.brandCode}
            options={getSelectedDictOne(DictCodeEnmu.MATERIAL_BRAND)}
            onChange={(e) => { setSearchWorkData({ ...searchWorkData, brandCode: e }) }}
            style={{ width: "150px" }}
            // placeholder="配件品牌"
            placeholder={Locale['Accessories brand']}
        />
        <Checkbox
            checked={searchWorkData.age ? true : false}
            onChange={(e) => {
                setSearchWorkData({ ...searchWorkData, age: e.target.checked ? 1 : 0 })
            }}
        >{Locale['Marketing Warehouse']}</Checkbox>
        <Button onClick={() => workloadData()} style={{ margin: "0px 5px 0px 10px" }} shape="round">{Locale["Search"]}</Button>
        <Button onClick={() => resetWorkloadData()} shape="round">{Locale["Reset"]}</Button>
    </div>
    const onOK = async () => {
        transformsToRoDetailList(mode)
        onCancel()
    }
    const onCancel = () => {
        setAddModalVisible(false);
        setAddDataSource([])
        setSearchWorkData({})
    };
    return <YHModal
        visible={visible}
        onOk={onOK}
        onCancel={onCancel}
        // title="选择用料"
        title={Locale["Select Materials"]}
        width={1000}
        bodyHeight={700}
        showFooter={true}
    >
        <YhBox title={Locale["List of materials to be selected"]} rightChildren={rightChildren} style={{ marginBottom: "15px" }}>
            <Table
                // size="small"
                rowKey={record => record.id as string}
                rowClassName='editable-row yh-edit-table-tr'
                columns={newSelectColumns(OPT_TYPE.ADD) as ColumnsType<IStockStatisticDetail>}
                dataSource={workDataSource}
                pagination={{
                    ...workPgCfg,
                    position: ["bottomCenter"],
                    onChange: (pageNum, pageSize) => {
                        workloadData({ pageNum, pageSize });
                    }
                }}
                components={{
                    body: {
                        row: EditableRow,
                        cell: EditableCell,
                    },
                }}
                onRow={record => ({
                    onClick: () => { }
                })}
                rowSelection={{
                    onSelectAll: (selected: boolean, selectedRows, changeRows) => {
                        // let changeRowId = changeRows.map(item => item.id);
                        selected ? setAddDataSource((origin) => [...origin, ...changeRows as any])
                            // : setAddDataSource((origin) => origin.filter(item => changeRowId.indexOf(item.id) < 0));
                            : setAddDataSource((origin) => origin.filter(item => !!!changeRows.find(finditem => finditem.id === item.id)))
                    },
                    selectedRowKeys: addDataSource.map(item => item.id) as string[]
                }}
                scroll={{ x: 'max-content', y: 200 }}
            />
        </YhBox>
        {/* <YhBox title="已选配件列表"> */}
        <YhBox title={Locale["List of selected materials"]}>
            <Table
                rowKey={record => record.id as string}
                rowClassName='editable-row yh-edit-table-tr'
                columns={newSelectColumns(OPT_TYPE.REMOVE) as ColumnsType<IStockStatisticDetail>}
                dataSource={addDataSource}
                pagination={false}
                components={{
                    body: {
                        row: EditableRow,
                        cell: EditableCell,
                    },
                }}
                onRow={record => ({
                    onClick: () => { }
                })}
                scroll={{ x: 'max-content', y: 200 }}
            />
        </YhBox>
    </YHModal>
}